import { HeadingProps } from '@chakra-ui/react';
import React from 'react';

import { CmHeading } from '@/components/uiParts';

export const PageHeading: React.FC<HeadingProps> = ({
  children,
  size = 'lg',
  ...rest
}) => {
  return (
    <CmHeading as="h1" size={size} {...rest}>
      {children}
    </CmHeading>
  );
};
